<div class="radios-container" [class.readonly]="readonly">
  @if (label) {
    <div class="header">
      <div class="label">{{ label }}</div>
    </div>
  }

  <ul class="radios-list" [class]="{ vertical: horizontalAlign, 'no-label': !label}">
    @for (option of options; track option.value; let index = $index) {
      <li>
        <label class="radio-label" [class.disabled]="option.disabled">
          <input
            type="radio"
            [attr.data-id]="controlId + 'radio-control-' + option.value"
            [tabIndex]="index"
            [name]="controlsName"
            [value]="option.value"
            [checked]="value === option.value"
            [disabled]="disabled || option.disabled"
            (change)="selectRadio(option, index)">
          <span class="out-circle"></span>
          <span class="inner-circle"></span>
          <span class="radio-text-label">{{ option.label }}</span>
        </label>
      </li>
    }
  </ul>

  @if (helperText) {
    <div class="helper">{{ helperText }}</div>
  }

  @if (displayValidationError) {
    <app-validation-error [customErrors]="customErrors"></app-validation-error>
  }
</div>
